"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.set = exports.get = exports.clear = exports.setLegacy = void 0;
var app_1 = __importDefault(require("../constants/app"));
var signalChange = function () {
    window.dispatchEvent(new Event(app_1.default.SESSION_STORAGE.GLOBAL_EVENT));
};
var setLegacy = function (data) {
    var canResolveFaults = data.canResolveFaults, _a = data.claims, claims = _a === void 0 ? [] : _a, hasFuelSubscription = data.hasFuelSubscription, hasSafetySubscription = data.hasSafetySubscription, infoModalVersionSeen = data.infoModalVersionSeen, _b = data.isAdmin, isAdmin = _b === void 0 ? false : _b, _c = data.isDtna, isDtna = _c === void 0 ? false : _c, _d = data.isRoot, isRoot = _d === void 0 ? false : _d, _e = data.isSafety, isSafety = _e === void 0 ? false : _e, _f = data.isXota, isXota = _f === void 0 ? false : _f, _g = data.isOps, isOps = _g === void 0 ? false : _g, _h = data.isCsAdmin, isCsAdmin = _h === void 0 ? false : _h, oid = data.oid, potaModalVersionSeen = data.potaModalVersionSeen, _j = data.profile, profile = _j === void 0 ? {} : _j, tanId = data.tanId, tanName = data.tanName;
    var sanitizedClaims = claims && claims.map(function (claim) { return claim.split(':')[2]; });
    sessionStorage.setItem(app_1.default.SESSION_STORAGE.LEGACY.PROFILE, JSON.stringify(profile));
    sessionStorage.setItem(app_1.default.SESSION_STORAGE.LEGACY.POTA_MODAL_VERSION_SEEN, potaModalVersionSeen.toString());
    sessionStorage.setItem(app_1.default.SESSION_STORAGE.LEGACY.LOGIN_ATTEMPTS, '0');
    sessionStorage.setItem(app_1.default.SESSION_STORAGE.LEGACY.LOGIN_ATTEMPTED, 'true');
    sessionStorage.setItem(app_1.default.SESSION_STORAGE.LEGACY.TAN_ID, JSON.stringify(tanId));
    sessionStorage.setItem(app_1.default.SESSION_STORAGE.LEGACY.TAN_NAME, JSON.stringify(tanName));
    sessionStorage.setItem(app_1.default.SESSION_STORAGE.LEGACY.TNAME_TABLES_MAIN_VEHICLES.replace(':tan_name', tanName), '""');
    sessionStorage.setItem(app_1.default.SESSION_STORAGE.LEGACY.IS_ROOT, JSON.stringify(isRoot));
    sessionStorage.setItem(app_1.default.SESSION_STORAGE.LEGACY.IS_DTNA, JSON.stringify(isDtna));
    sessionStorage.setItem(app_1.default.SESSION_STORAGE.LEGACY.IS_ADMIN, JSON.stringify(isAdmin));
    sessionStorage.setItem(app_1.default.SESSION_STORAGE.LEGACY.IS_SAFETY, JSON.stringify(isSafety));
    sessionStorage.setItem(app_1.default.SESSION_STORAGE.LEGACY.IS_CS_ADMIN, JSON.stringify(isCsAdmin));
    sessionStorage.setItem(app_1.default.SESSION_STORAGE.LEGACY.IS_OPS, JSON.stringify(isOps));
    sessionStorage.setItem(app_1.default.SESSION_STORAGE.LEGACY.IS_XOTA, JSON.stringify(isXota));
    sessionStorage.setItem(app_1.default.SESSION_STORAGE.LEGACY.INFO_MODAL_VERSION_SEEN, infoModalVersionSeen.toString());
    sessionStorage.setItem(app_1.default.SESSION_STORAGE.LEGACY.HAS_FUEL_SUBSCRIPTION, "".concat(hasFuelSubscription));
    sessionStorage.setItem(app_1.default.SESSION_STORAGE.LEGACY.HAS_SAFETY_SUBSCRIPTION, "".concat(hasSafetySubscription));
    sessionStorage.setItem(app_1.default.SESSION_STORAGE.LEGACY.CAN_RESOLVE_FAULTS, "".concat(canResolveFaults));
    sessionStorage.setItem(app_1.default.SESSION_STORAGE.LEGACY.OID, oid);
    sessionStorage.setItem(app_1.default.SESSION_STORAGE.LEGACY.CLAIMS, JSON.stringify(sanitizedClaims));
    signalChange();
};
exports.setLegacy = setLegacy;
var clear = function () {
    sessionStorage.clear();
    signalChange();
};
exports.clear = clear;
var get = function (item) {
    try {
        return JSON.parse(sessionStorage.getItem(item));
    }
    catch (_) {
        return sessionStorage.getItem(item);
    }
};
exports.get = get;
var set = function (name, value) {
    sessionStorage.setItem(name, JSON.stringify(value));
    signalChange();
};
exports.set = set;
var sessionStorageExport = {
    get: exports.get,
    set: exports.set,
    setLegacy: exports.setLegacy,
    clear: exports.clear,
};
exports.default = sessionStorageExport;
